import Welcome from "@/pages/welcome/Welcome";
import {createFileRoute} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {z} from "zod";

export const Route = createFileRoute("/welcome")({
  component: Welcome,
  validateSearch: zodValidator(
    z.object({
      access_token: z.string().optional(),
      agency_id: z.number().optional(),
      company_id: z.number().optional(),
      email: z.string().optional(),
      is_registering_user: z.boolean().optional(),
      permission: z.string().optional(),
      token: z.string().optional(),
    }),
  ),
});
